module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "ch02"
    }
  }, [_c('span', {
    staticClass: "txbfit"
  }, [_vm._v("2"), _c('br'), _vm._v("Sorrow for the Lost")])])]), _c('a', {
    attrs: {
      "id": "ch02"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Isobel awoke with a start. She sucked in a sharp gasp of air, and her gaze met with the blank surface of her bedroom ceiling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She blinked as a swirl of images shuttered through her brain like snapshots in a broken reel of film. Closing her eyes, she tried to find one frame to latch on to, one fleeting symbol or shadow that would trigger the memory of what it was she’d been dreaming about.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the pictures slid by too quickly, growing dimmer and more uncertain the faster her consciousness swam toward the surface of reality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel groaned. She didn’t want to wake up. She wanted to slip under again. She wanted to go back.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rolling onto her side, she peered groggily through the narrow slice of window visible between her twin white-lace curtains.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was still dark outside, still early.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }, [_vm._v("If she threw the covers over her head and tried to sleep again, Isobel wondered if she would be able to return to whatever dream she’d been having. Even if she couldn’t recall where she had been or what had been happening, she knew that the dream had not had a chance to end where it should ")]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("have. There had been something left unsaid. No, she thought, there had been something left undone. What was it?")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel sighed. It was no use straining. The thread was broken.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She turned to glance at her digital clock.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("6:30, it read in cool blue numbers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She froze.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Oh my God. Six freaking thirty?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("An ice bomb exploded somewhere in the pit of her stomach, set off by the sudden realization that she was supposed to be on a bus right that very moment, a bus that had probably reached the county line by now, filled with every member of Trenton High’s varsity cheerleading squad. Every member except "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("her")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("“Daaaad!”")]), _vm._v(" Her voice scraped raw from the back of her throat. Isobel tossed off her covers, her legs prickling with gooseflesh as she staggered out of bed, hurtling toward her bedroom door. She threw it open and rushed out and onto the landing that overlooked the foyer and downstairs hallway.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Darkness bathed the house, quietness filling every corner.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the end of the hall, Danny’s bedroom door stood ajar, and Isobel could just make out her little brother’s snores emanating from within.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She hurried to the stairs, not caring if she woke him, her bare feet thundering down the carpet-covered steps. “Da—”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Isobel jerked to a halt midway down, surprised to see her father enter the foyer, his upturned face clean-shaven, his ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("expression questioning. He held his briefcase in one hand, a travel mug of coffee in the other. He wore black slacks and a clean white button-down shirt, the silver pin-striped tie she’d given him last Father’s Day laced through the collar.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He raised his eyebrows at her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Miss the bus again, kiddo?” he asked, a slightly bemused look on his face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel stood motionless on the stairs, her thoughts racing. As the blank spaces of all the current whens and wheres refilled, the frantic beating of her heart began to slow. Spotting the darkened Christmas tree through the living room archway, she felt a warm gush of relief wash through her.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nationals. The competition. It had all already happened. She’d been home from Dallas for a week now. She hadn’t missed the bus, either. In fact, she’d been early.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They had won, too. Trenton High Spirit Squad now held the all-too-rare title of three-time NCA champions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel could still hear the squad’s piercing screams of victory echo through her head. In her mind’s eye, she pictured them all huddled together, a squealing, teary mob of blue and yellow, everyone clamoring to lay a hand on the gleaming golden trophy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Third time this week,” her father said, drawing Isobel’s attention back to his presence in the foyer.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("With glazed eyes, she followed his movements as he set his briefcase down next to the umbrella stand. He stepped forward, grabbing his gray wool peacoat from where he’d hung it on the banister post. Juggling the coffee mug between ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("his hands, he kept his gaze steady on her while he shrugged the coat on one sleeve at a time.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Think I’m going to have to talk to Coach about this,” he said. “Tell her to cool it a little next time on all those extra practices. I’m just waiting for the day you wake up from the nightmare where you think you "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("lost")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel grasped the stairway banister. She clutched the wood hard, her fingernails digging into the cherry finish. Slowly she lowered herself to sit on the edge of one step while fragments from her dream began to resurface, bobbing up like driftwood from a shipwreck. Amid the tangle of familiar and unfamiliar, mundane and frightening, one quiet face floated forward to occupy the forefront of her mind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was beginning to wonder if she would ever again be able to picture his eyes the way they’d been before . . . before . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey. Relax, Izzy,” her father said, leaning forward to nudge her knee with a fist. “Trophy’s in the bag, champ.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The dream—it always started out with her being at final practice. And though she’d had it a handful of times now, it had never lasted so long. Every time before this, every "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("single")]), _vm._v(" time, she’d awoken as soon as she saw him—as soon as she realized that his being there wasn’t possible and that she had to be dreaming. In other words, as soon as she became lucid.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This time had been different, though. Somehow she’d managed to forget about reality long enough to remain within the dream. Long enough for him to show her what he’d wanted her to see.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But what "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("had")]), _vm._v(" he wanted her to see?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("“Sooo,” her dad said. “I know it’s Christmas Eve, but as you can probably guess, I’ve got to head into the office for a couple hours. Very Bob Cratchit of me, I know.” He checked his wristwatch. “I should be back early, though. Noon at the latest. You and I are still on for our last-minute mall trip, right? I still have to pick up your mother’s gift from the jeweler. Orange Julius on me?”")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel nodded at him. She’d have agreed to anything in that moment so long as it would make him go away, so long as it would let her be alone again so she could concentrate on salvaging the bits and pieces of time spent with Varen, even if she couldn’t be 100 percent certain if those moments had been real.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("had")]), _vm._v(" to have been real, though. It only made sense that he would try to reach her this way. He had seemed so solid, so there. Her hand still tingled from where he’d held it, her skin alive with the memory of his warmth.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oooo-kay,” Isobel heard her dad say, “then I’ll call when I’m on my way to pick you up. In the meantime, Izzy, why don’t you try going back to bed? I think you’re still a little worn out from the all the competition stuff. I mean, they call it winter "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("break")]), _vm._v(" for a reason.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Again, Isobel nodded. Nod, nod, nod. It was what she did best these days.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Concern flashed across his features, and his smile faltered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Quickly she found her voice. “You’re probably right,” she said.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("He continued to watch her, frowning, like there was still ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("something else he wanted to say. Instead of saying it, though, he pushed his smile into place again. Turning, he opened the front door and let in a burst of frigid winter air.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Even though the sudden brush of cold wind should have sent a shiver rattling through her, it didn’t.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Outside, Isobel could see that the deep blue darkness had since lightened, evidence that the dawn was doing its best to push back the curtain of night.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her father remained only a moment longer before bending, at last, to pick up his briefcase.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll call you, okay?” he said. He raised his coffee mug to the side of his head as though it were a cell phone, like he thought she needed sign language.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yeah,” she said, “sounds good.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He gave a half wave, then shuffled out, poking his head back in at the last moment to say, “Grab the door for me?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Isobel pushed herself up from the stairs. She pressed the door closed behind him while her father shouldered his way past the outer storm door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She leaned her forehead against the wood, listening to his shoes click against the sidewalk as his footsteps grew distant.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With her hand still gripping the knob, she caught herself wishing she could run after him and call him back. Time and again she’d had to fight the urge to tell him everything, even though she knew he would never believe any of it.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("A moment longer, though, and she might have confessed that actually, she "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("had")]), _vm._v(" had the nightmare he’d mentioned—the ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("one where she’d lost. But unlike the recurring dream about practice, it hadn’t concerned Nationals at all.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("It had concerned everything else. The "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("only")]), _vm._v(" thing else.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But it hadn’t been a dream.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("These days, it was getting harder and harder to tell what was.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She spun, putting her back to the door, listening to the quiet hum of the sedan’s engine as her father backed the car out of the driveway and onto their street.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The twin beams of the headlights flashed through the living room window, casting a host of misshapen shadows along the floors and walls, making Isobel feel suddenly less alone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A chill climbed up her spine, receding only when dimness and silence settled over the house once more.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She glanced up to the darkened doorway of her bedroom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Her dad had told her to try to go back to sleep. Now that she was wide awake, though, Isobel began to doubt if she would ever know true rest again.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1a756f6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 75
// module chunks = 0